import React,{ useState,useEffect} from 'react'
import { Breadcrumb } from 'antd';
import { withRouter, useHistory } from 'react-router-dom'
import { getUserInfo } from '@/common/api/user';
import { listConvertTree,sortDataByKey } from '@/common/js/utils';
function Navigation(props) {
    const [navigationDom, setnavigationDom] = useState(() => {})
    let list = []
    let name = []
    let num = 1
    /**
     * 生成面包屑DOM的方法
     * function getNavigation
     */
    function getNavigation (list, newpath, num) {
        const oldPath = props.routerPath.location.pathname
        let newnum = num
        list.some(item => {
            if (item.menuCode === '' || item.menuCode === newpath) {
                name.push(item.menuName)
                if (item.path === oldPath) {
                    return name.map((item, index) => {
                        return (
                            <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
                        )
                    })
                } else {
                    if (item.children && item.children.length > 0) {
                        newnum = newnum + 1
                        getNavigation(item.children, (oldPath.split('/'))[newnum], newnum)
                    }
                }
            }
        })
        return name.map((item, index) => {
            return (
                <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
            )
        })
    }
    /**
     * function handleUserInfo
     * 获取用户信息并生成dom树
     */
    function handleUserInfo() {
        getUserInfo().then(res => {
            const opt = {
                primaryKey: 'id',
                parentKey: 'parentId',
                startPid: '-1'
            }
            if (res.code === 0 && res.data && res.data.menuList.length > 0) {
                res.data.menuList.map(item => {
                    item.key = item.id
                    item.value = item.id
                    item.label = item.menuName
                    return item
                })
                res.data.menuList = sortDataByKey(res.data.menuList,'priority','asc')
                const data = listConvertTree(res.data.menuList, opt)
                list = data
                const dom = getNavigation(data, props.location.pathname.split('/')[1], num)
                setnavigationDom(dom)
            }
        })
    }
    const history = useHistory()
    useEffect(() => {
        handleUserInfo()
        /**
         * 全局监听路由变化
         * 根据路由创建面包屑dom
         */
        history.listen(historyLocation => {
            name = []
            const listenPath = props.routerPath.location.pathname.split('/')[1]
            const dom = getNavigation(list, listenPath, num, historyLocation.pathname)
            setnavigationDom(dom)
            // 如果路由离开售后记录管理页面，清除session中存储的标签页数据
            if (props.routerPath.location.pathname.lastIndexOf('/workOrderAdministration/aftermarket') === -1){
                sessionStorage.removeItem('dl_scmp_aftermarket_tabkey')
            }
        })
    },[])
    return (
        <Breadcrumb style={{ margin: '16px 0' }}>
            {navigationDom}
        </Breadcrumb>
    )
}
export default withRouter(Navigation)
